import { Outlet } from "react-router-dom";

import HalloweenDecor from "../../components/HalloweenDecor/HalloweenDecor";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import { getActiveSeason, SEASON_HALLOWEEN } from "../../utils/season";
import styles from "./MainLayout.module.scss";

export default function MainLayout() {
  const isHalloween = getActiveSeason() === SEASON_HALLOWEEN;

  return (
    <div className={styles.layout}>
      {isHalloween && <HalloweenDecor />}
      <Navbar />
      <main className={styles.main}>
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
